'use client'

import { SpecialCard } from '@/types/api/ui-placement'
import { Article } from '@/types/Article'
import { format } from 'date-fns'
import Card from '../../atoms/card/card'
import { SpecialCard as SpecialCardComponent } from '../../atoms/special-card/special-card'
import s from './special-card-with-article.module.css'

type Props = {
  specialCard: SpecialCard
  article?: Article
  specialCardHeadingLevel?: 'h2' | 'h3' | 'h4'
  cardHeadingLevel?: 'h2' | 'h3' | 'h4'
}

export const SpecialCardWithArticle = ({
  specialCard,
  article,
  specialCardHeadingLevel,
  cardHeadingLevel,
}: Props) => {
  return (
    <div className={s.container}>
      <div className={s.topWrapper}>
        <div className={s.specialCardWrapper}>
          <SpecialCardComponent
            category={specialCard.article.article_categories?.name!}
            date={format(specialCard?.article.published_date!, 'dd.MM.yyyy')}
            header={specialCard.article.title!}
            imageUrl={specialCard.article.hero_image_ref.url!}
            description={
              specialCard.article.introduction_copy ||
              specialCard.article.description
            }
            path={specialCard.article.path!}
            itemId={specialCard.article.id!}
            type="featureCard"
            theme={specialCard.theme}
            headingLevel={specialCardHeadingLevel}
          />
        </div>

        {!!article && (
          <div className={s.mainCardWrapper}>
            <Card
              imageUrl={article.hero_image_ref.url}
              imageAlt={article.hero_image_ref.alt}
              path={article.path}
              header={article.title}
              date={format(article.published_date!, 'dd.MM.yyyy')}
              itemId={article.id}
              category={
                article.article_subcategories?.name! ||
                article.article_categories?.name!
              }
              type="Article"
              size="Large"
              key={article.id}
              headingLevel={cardHeadingLevel}
            />
          </div>
        )}
      </div>
    </div>
  )
}
